import { createContext } from 'react';

/**
 * @typedef CbgEntry
 * @property {string} id
 * @property {import('@mui/material/styles/createBreakpoints').Breakpoint} down
 * @property {import('@mui/material').ButtonProps} props
 */

function throwForNoContext() { throw new Error('No CbgContext in tree.'); }

export default createContext({
    /**
     * @param {CbgEntry} entry
     * @returns {void}
     */
    update(entry) { throwForNoContext(); },
    /**
     * @param {string} id
     * @returns {void}
     */
    unregister(id) { throwForNoContext(); },
});